<template>
	<div class="markdown prose">
        <p>Great! Inspired by Soros? So are we. With Untrading , you don’t just capitalize on being right—you amplify it. No commissions, no predictions, just pure asymmetric opportunities to maximize your wins. Frictionless, fearless, and fully in your control.</p>
    </div>
</template>